import React, { Component } from "react";
import "./styles.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../../actions/application";
import { withRouter } from "react-router-dom";

class PatientBanner extends Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div id="patientBanner">
        {this.props.visible && (
          <img
            src={require("../images/" +
              this.props.currentPatient +
              "_patientbanner.png")}
            className="image"
            alt=""
          />
        )}
      </div>
    );
  }
}

const ConnectedPatientBanner = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(PatientBanner);

export default withRouter(ConnectedPatientBanner);
